(() => {
  document.addEventListener("click", (e) => {
    const trigger = e.target.closest("[data-product-sidebar-open]");
    if (!trigger) return;

    const drawerId = trigger.getAttribute("data-drawer-target");
    if (!drawerId) return;

    const drawer = document.getElementById(drawerId);
    if (drawer && typeof drawer.openDrawer === "function") {
      e.preventDefault();
      drawer.openDrawer();
    }
  });

  if (!customElements.get("product-sidebar-drawer")) {
    class ProductSidebarDrawer extends HTMLElement {
      constructor() {
        super();

        this.drawerWrapper = this.querySelector(".m-drawer__wrapper");
        this.drawerContent = this.querySelector(".m-drawer__content");
        this.drawerClose = this.querySelector(".m-drawer__close");

        this._portalPlaceholder = null;
        this._isPortalized = false;

        this.onKeydown = this.onKeydown.bind(this);
        this.onOverlayClick = this.onOverlayClick.bind(this);

        if (this.drawerClose) {
          this.drawerClose.addEventListener("click", (e) => {
            e.preventDefault();
            this.closeDrawer();
          });
        }

        document.addEventListener("keydown", this.onKeydown);

        // IMPORTANT: move drawer to <body> so the overlay covers full page
        this.portalToBody();
      }

      disconnectedCallback() {
        document.removeEventListener("keydown", this.onKeydown);

        // Optional cleanup: if element is removed from DOM, return wrapper back
        this.unportalFromBody();
      }

      portalToBody() {
        if (!this.drawerWrapper || this._isPortalized) return;

        // Put a placeholder where the wrapper used to be (so DOM structure remains valid)
        this._portalPlaceholder = document.createComment("product-sidebar-drawer-portal");
        this.drawerWrapper.parentNode.insertBefore(this._portalPlaceholder, this.drawerWrapper);

        // Move wrapper to body
        document.body.appendChild(this.drawerWrapper);
        this._isPortalized = true;

        // Overlay click should close ONLY when clicking the overlay itself
        this.drawerWrapper.addEventListener("click", this.onOverlayClick);
      }

      unportalFromBody() {
        if (!this.drawerWrapper || !this._isPortalized) return;

        this.drawerWrapper.removeEventListener("click", this.onOverlayClick);

        if (this._portalPlaceholder && this._portalPlaceholder.parentNode) {
          this._portalPlaceholder.parentNode.insertBefore(this.drawerWrapper, this._portalPlaceholder);
          this._portalPlaceholder.remove();
        }

        this._portalPlaceholder = null;
        this._isPortalized = false;
      }

      onOverlayClick(e) {
        // Only close when clicking the wrapper background, not the drawer content
        if (e.target === this.drawerWrapper) {
          this.closeDrawer();
        }
      }

      onKeydown(e) {
        if (e.key === "Escape") this.closeDrawer();
      }

      openDrawer() {
        if (!this.drawerWrapper || !this.drawerContent) return;

        // Ensure it is portalized even if DOM changed
        this.portalToBody();

        // Lock background scroll only on desktop (mobile touch scrolling is naturally confined)
        if (window.innerWidth >= 770) {
          document.documentElement.classList.add("prevent-scroll");
        }

        // Keep theme "mobile" class behavior if needed by existing CSS
        if (window.innerWidth < 770) {
          this.drawerWrapper.classList.add("mobile");
        } else {
          this.drawerWrapper.classList.remove("mobile");
        }

        this.drawerWrapper.classList.remove("m:hidden");
        this.initAccordions();

        requestAnimationFrame(() => {
          this.drawerWrapper.style.setProperty("--m-bg-opacity", "0.5");
          this.drawerContent.style.setProperty("--m-translate-x", "0");
        });
      }

      closeDrawer() {
        if (!this.drawerWrapper || !this.drawerContent) return;

        this.drawerWrapper.style.setProperty("--m-bg-opacity", "0");
        this.drawerContent.style.setProperty("--m-translate-x", "100%");

        setTimeout(() => {
          this.drawerWrapper.classList.add("m:hidden");
          this.drawerWrapper.classList.remove("mobile");

          // Only unlock scroll if no other drawer/overlay needs it
          // Check if sticky cart is expanded or if any other drawer is open
          const stickyCartExpanded = document.querySelector('.m-sticky-addtocart--mobile-wrapper.is-expanded');
          const otherDrawerOpen = document.querySelector('.m-drawer__wrapper:not(.m\\:hidden):not([style*="--m-bg-opacity: 0"])');

          if (!stickyCartExpanded && !otherDrawerOpen) {
            document.documentElement.classList.remove("prevent-scroll");
          }
        }, 300);
      }
      initAccordions() {
        if (!this.drawerWrapper) return;
        if (!window.MinimogLibs || !MinimogLibs.Accordion) return;

        this.drawerWrapper
          .querySelectorAll(".m-product-sidebar__accordion.m-accordion")
          .forEach((el) => {
            new MinimogLibs.Accordion(el, { presetContentHeight: true });
          });
      }

    }

    customElements.define("product-sidebar-drawer", ProductSidebarDrawer);
  }
})();
